module.exports = __webpack_public_path__ + "static/media/01_registro_frase_3.fbf0cc0d.png";